import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import {FloatLabel} from "primereact/floatlabel";
import {Button} from "primereact/button";
import {useDialog} from "../../../lib/hooks/useDialog";
import {Api, ReportChunk} from "../../../lib/services/mainApi";
import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";
import {Dropdown} from "primereact/dropdown";
import {ReactiveTable} from "react-ive-tables";

interface Props {
    usernameOptions: IDropdownOption[]
}

const ReportDialog: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);

    const {hideDialog} = useDialog();
    const api = new Api();

    const [username, setUsername] = useState<number>();

    const [reportData, setReportData] = useState<ReportChunk[]>()

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const handleExport = () => {
        if (!username) return;
        api.api.adminV1Reportv2Detail(username)
            .then(res => {
                setReportData(res.data.reports || [])
            })
    }

    // const renderReport = () => {
    //     if(!reportData) return <></>
    //     return <div className={"flex justify-content-center w-full"}>
    //         {Object.values(reportData).map(el => {
    //             return <div className={"border-round-3xl p-6 m-4 text-white"} style={{background: "orange"}}>
    //                 {/*{el.buttonName} - {el.timesClicked}*/}
    //             </div>
    //         })}
    //     </div>
    // }

    const getColumnTemplate = () => {
        return {
            breakfast: (rowData: ReportChunk) => rowData.itemsWithStat?.find(el => el.description === "Breakfast")?.sum,
            supper: (rowData: ReportChunk) => rowData.itemsWithStat?.find(el => el.description === "Supper")?.sum,
            lunch: (rowData: ReportChunk) => rowData.itemsWithStat?.find(el => el.description === "Lunch")?.sum,
            snack: (rowData: ReportChunk) => rowData.itemsWithStat?.find(el => el.description === "Snack")?.sum
        }
    }

    return <div className={"flex grid"}>
        <FloatLabel className={"col-12 mt-4"}>
            <Dropdown id="username" className={"p-inputtext-lg w-full"} value={username}
                      onChange={(e) => setUsername(e.value)} options={props.usernameOptions} optionLabel={"description"}
                      optionValue={"id"}/>
            <label className={"ml-2"} htmlFor="username">{f({id: "username"})}</label>
        </FloatLabel>

        <div className={"col-12 flex justify-content-between"}>
            <Button className={"col-4"} label={f({id: "export"})} disabled={!username} onClick={handleExport}/>
            <Button className={"col-4"} label={f({id: "cancel"})} onClick={hideDialog}/>
        </div>


        {reportData &&
            <ReactiveTable columnOrder={['usCentralDate', 'total', 'breakfast', "lunch", 'supper', 'snack']}
                           data={reportData} columnTemplate={getColumnTemplate()}/>
        }

    </div>
};

export default ReportDialog
